import * as React from 'react';
import {faBookOpen, faClipboardList, faFileInvoice, faFileSpreadsheet} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {WebAsset} from '../item.class';
import {PageHeader} from '../../ui/PageHeader/PageHeader';

type SupportingDocumentsProps = {
    supportingDocuments: WebAsset[];
};

export const SupportingDocuments = ({supportingDocuments}: SupportingDocumentsProps) => {
    const getIcon = (referenceType: string) => {
        let iconName = faBookOpen;
        switch (referenceType) {
            case 'owners_document_ref':
                iconName = faClipboardList;
                break;
            case 'Support_Document_Ref':
                iconName = faFileInvoice;
                break;
            case 'Backsheet_Doc_Ref':
                iconName = faFileSpreadsheet;
                break;
        }
        return iconName;
    };
    return (
        <div className="tw-mb-5 print:hidden">
            <PageHeader
                title="Documents"
                type="h4"
            />
            <div className="tw-flex tw-flex-wrap tw-flex-row">
                {supportingDocuments.map((supportingDocument, index) => {
                    if (supportingDocument.fileLocation && supportingDocument.referenceType !== 'california_support_document') {
                        return (
                            <a
                                key={index}
                                className="tw-mb-3 tw-text-black hover:tw-text-black hover:tw-no-underline tw-inline-block"
                                href={`/${supportingDocument.fileLocation}`}
                                target="_blank"
                            >
                                <div className="tw-min-h-[115px] tw-text-center tw-w-[104px] tw-mx-2 tw-px-2 card tw-h-full tw-pb-1">
                                    <FontAwesomeIcon
                                        className="tw-my-3"
                                        size="3x"
                                        icon={getIcon(supportingDocument.referenceType)}
                                    />
                                    <span className="tw-text-sm tw-font-normal tw-leading-[1.3]">{supportingDocument.name}</span>
                                </div>
                            </a>
                        );
                    }
                })}
            </div>
        </div>
    );
};
